var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 15.1667C4.04659 15.1667 0.833252 11.9533 0.833252 8.00001C0.833252 4.04668 4.04659 0.833344 7.99992 0.833344C11.9533 0.833344 15.1666 4.04668 15.1666 8.00001C15.1666 11.9533 11.9533 15.1667 7.99992 15.1667ZM7.99992 1.83334C4.59992 1.83334 1.83325 4.60001 1.83325 8.00001C1.83325 11.4 4.59992 14.1667 7.99992 14.1667C11.3999 14.1667 14.1666 11.4 14.1666 8.00001C14.1666 4.60001 11.3999 1.83334 7.99992 1.83334Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6666 8.5H5.33325C5.05992 8.5 4.83325 8.27333 4.83325 8C4.83325 7.72667 5.05992 7.5 5.33325 7.5H10.6666C10.9399 7.5 11.1666 7.72667 11.1666 8C11.1666 8.27333 10.9399 8.5 10.6666 8.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.1667C7.72667 11.1667 7.5 10.94 7.5 10.6667V5.33334C7.5 5.06001 7.72667 4.83334 8 4.83334C8.27333 4.83334 8.5 5.06001 8.5 5.33334V10.6667C8.5 10.94 8.27333 11.1667 8 11.1667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircle);
export default __webpack_public_path__ + "static/media/add-circle.d84229b0df9d3ad46f030d57a9cb8ef0.svg";
export { ForwardRef as ReactComponent };